/**
 * Empty State Component
 * Shown when no transactions match current filters
 */

import {
  Box, Typography, Button, Card, CardContent,
  useTheme, alpha
} from '@mui/material';
import {
  Receipt as ReceiptIcon,
  FilterAltOff as FilterAltOffIcon
} from '@mui/icons-material';

export default function EmptyState({ hasTransactions, onClearFilters }) {
  const theme = useTheme();

  return (
    <Card sx={{
      borderRadius: 4,
      textAlign: 'center',
      border: `1px solid ${alpha(theme.palette.grey[400], 0.8)}`,
      background: `linear-gradient(135deg, ${alpha(theme.palette.grey[50], 0.8)}, ${alpha(theme.palette.grey[100], 0.4)})`,
      transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
    }}>
      <CardContent sx={{ p: 8 }}>
        <Box sx={{
          p: 3,
          borderRadius: 3,
          bgcolor: alpha(theme.palette.primary.main, 0.1),
          border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
          display: 'inline-flex',
          mb: 3
        }}>
          <ReceiptIcon sx={{ fontSize: 64, color: 'primary.main' }} />
        </Box>
        <Typography variant="h4" sx={{ fontWeight: 500, mb: 2, color: 'text.primary' }}>
          No Transactions Found
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{
          mb: 4,
          fontWeight: 500,
          fontSize: '1rem',
          maxWidth: 400,
          mx: 'auto'
        }}>
          {hasTransactions
            ? 'No transactions match your current filters. Try adjusting your search criteria.'
            : 'Transactions will appear here when you add, transfer, or use inventory from the Inventory List tab.'
          }
        </Typography>
        {hasTransactions && (
          <Button
            variant="outlined"
            startIcon={<FilterAltOffIcon />}
            onClick={onClearFilters}
            sx={{
              borderRadius: 2,
              px: 4,
              py: 1.5,
              fontWeight: 500,
              fontSize: '1rem'
            }}
          >
            Clear All Filters
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
